module.exports = __webpack_public_path__ + "static/img/LUKE-TRAINOR.fdb708a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/LUKE-TRAINOR.jpg
// module id = SBLI
// module chunks = 0